module.exports = __webpack_public_path__ + "mt.svg?d96e7a618510c4ebd369579d68df5932";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/1x1/mt.svg
// module id = 886
// module chunks = 27